<template>
    <main class="main about-brand-page">
        <section class="sec-about">
            <div class="">
                <div class="image-wrapper">
                    <img :src="'/img/about-bckg.png'" class="img-element" alt="">
                    <div class="gradient"></div>
                </div>

                <p class="primary-text">
                    {{ trans("Bat Norton was founded with a simple yet bold vision: to create garments where design, function, and cultural depth merge into a single language of self-expression. Each piece is developed by our design team and produced under our direct supervision, ensuring control at every stage — from sketch to final garment") }}.
                </p>

                <h1 class="about-brand-page__title">
                    {{ trans("Introducing Bat Norton® — a combination of quality and creativity") }}.
                </h1>

                <div class="store-body__video-container">
                    <div class="video-box">
                        <video id="video" muted="muted" loop="loop" playsinline="" class="img-element">
                            <source src="https://batnorton.com/videos/66bdd5d552b08.mp4" type="video/mp4">
                        </video>
                        <div id="video-btn" class="video__play" @click="videoPlay" v-show="icon_play">
                            <svg class="svg-icon" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect y="0.5" width="48" height="48" rx="24" fill="white"></rect>
                                <path d="M31.3328 24.4999L20.666 16.5V32.5L31.3328 24.4999Z" fill="black"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="welcome-sec__advantages">
                    <h3 class="welcome-sec__advantages-title">
                        {{
                            trans("We use premium materials to create clothes that combine comfort and style")
                        }}.
                    </h3>
                    <div class="welcome-sec__advantages-row">
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <p class="text-element">{{ trans('Unique design') }}</p>
                        </div>
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <p class="text-element">{{ trans('Own production') }} </p>
                        </div>
                        <div class="welcome-sec__advantages-element">
                            <svg class="svg-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.791 9.75L11.291 15L8.54102 12.375" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12.666 21C17.6366 21 21.666 16.9706 21.666 12C21.666 7.02944 17.6366 3 12.666 3C7.69545 3 3.66602 7.02944 3.66602 12C3.66602 16.9706 7.69545 21 12.666 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <p class="text-element">{{ trans("Worldwide shipping") }}</p>
                        </div>
                    </div>
                </div>

                <div class="about-brand-page__posts">
                    <div class="about-brand-page__post">
                        <div class="about-brand-page__post-img">
                            <picture>
                                <img :src="'/img/about5.png'" class="img-element" alt="">
                            </picture>
                        </div>
                        <div class="about-brand-page__post-text">
                            <div>
                                <h1 class="about-brand-page__title" style="text-align: start">
                                    {{ trans("Core Principles") }}
                                </h1>
                                <ul>
                                    <li>
                                        <span class="text-element"><b>{{ trans("Own Production & Quality Control") }}</b></span>
                                        <p class="text-element">{{ trans("Every item passes through rigorous selection and inspection") }}</p>
                                    </li>
                                    <li>
                                        <span class="text-element"><b>{{ trans("High-Quality Fabrics & Hardware") }}</b></span>
                                        <p class="text-element">{{ trans("Materials and details are chosen for durability, comfort, and precision") }}</p>
                                    </li>
                                    <li>
                                        <span class="text-element"><b>{{ trans("Design Language") }}</b></span>
                                        <p class="text-element">{{ trans("Bold silhouettes, clean lines, a balance of minimalism and avant-garde") }}</p>
                                    </li>
                                    <li>
                                        <span class="text-element"><b>{{ trans("Unisex Approach") }}</b></span>
                                        <p class="text-element">{{ trans("Most pieces transcend gender, adapting to individuality") }}</p>
                                    </li>
                                    <li>
                                        <span class="text-element"><b>{{ trans("Creative Direction") }}</b></span>
                                        <p class="text-element">{{ trans("Each design is born in-house, shaped by our vision and craftsmanship") }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="about-brand-page__post">
                        <div class="about-brand-page__post-text">
                            <div>
                                <p class="text-element">
                                    {{trans("We deliver the quality you expect from premium brands, but at accessible prices. Bat Norton is not about trends — it is about form, texture, and identity. A quiet yet powerful statement for those who choose authenticity")}}.
                                </p>
                            </div>
                        </div>
                        <div class="about-brand-page__post-img">
                            <picture>
                                <img :src="'/img/about6.png'" class="img-element" alt="">
                            </picture>
                        </div>
                    </div>
                </div>

                <div class="about-brand-page__banner2">
                    <div class="about-brand-page__namer2-img">
                        <div class="image-wrapper">
                            <img :src="'/img/about-footer.png'" class="img-element" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    name: "index",
    methods:{
        videoPlay(){
            $('#video').get(0).play()
            $(this).remove()
            this.icon_play = false
        },
    },
    data(){
        return{
            icon_play:true,
        }
    }
}
</script>

<style scoped>
.sec-about {
    padding: 0;
}

.image-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: 40px;
}

.image-wrapper img {
    width: 100%;
    height: auto;
    display: block;
}

.image-wrapper .gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40%;
    background: linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0));
}

.primary-text {
    color: white;
    width: 50%;
    text-align: justify;
    margin: 0 auto;
    font-size: 25px;
    line-height: 110%;
    font-weight: 300;
}

.about-brand-page__title {
    margin: 200px auto 100px auto;
}

.about-brand-page__post {
    padding: 0;
    border: none;
    display: flex;
    .about-brand-page__post-img {
        flex: 1;
        width: 50%;
        height: auto;
    }
    .about-brand-page__post-text {
        div {
            padding: 40px;
        }
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .about-brand-page__title {
            margin: 0 auto 20px auto;
        }
    }
}

.about-brand-page__banner2 {
    margin: 0;
}

.about-brand-page__post-text .text-element{
    font-size: 25px;
    line-height: 110%;
    margin-top: 4px;
    font-weight: 300;
    b {
        font-weight: bold;
    }
}

.sec-about .store-body__video-container {
    .video-box {
        border-radius: 10px;
        overflow: hidden;
    }
}

.about-brand-page__namer2-img {
    height: 900px;
}

.sec-about .welcome-sec__advantages {
    padding: 80px 80px 120px 80px;
}
ul {
    padding-left: 20px;
}

ul li {
    list-style-position: inside;
    padding-left: 0;
    /* Bullet color */
    color: white;
    list-style-type: disc;
    font-size: 20px;
    p.text-element {
        margin-left: -20px;
        font-size: 22px!important;
    }
}
@media screen and (max-width: 480px) {
    ul {
        padding-left: 15px;
        li {
            margin-left: -10px;
            font-size: 10px;
            p.text-element {
                margin: 0 0 10px -7px;
            }
        }
    }

    .primary-text {
        width: 70%;
        font-size: 12px;
        font-weight: 300;
        line-height: 120%;
        letter-spacing: 0px;
    }

    .about-brand-page__title {
        margin: 60px 30px 60px 30px;
    }
    .about-brand-page__post {
        .about-brand-page__title {
            margin: 5px 0px 20px 0px;
            font-size: 18px;
            line-height: 110%;
            letter-spacing: 0.76px;
            text-align: left;
        }
    }

    .welcome-sec__advantages-element {
        width: 80%;
        margin-bottom: 20px;
    }

    .about-brand-page__post {
        flex-direction: column;
        .about-brand-page__post-img {
            width: 100%;
        }

        .about-brand-page__post-text {
            width: 100%;
            div {
                padding: 40px 40px 40px 40px;
            }
        }
    }

    /* во второй строке поменяем порядок */
    .about-brand-page__post:nth-child(2) .about-brand-page__post-text {
        order: 2;
    }

    .about-brand-page__post:nth-child(2) .about-brand-page__post-img {
        order: 1;
    }

    .image-wrapper {
        height: 800px;
        margin-bottom: 20px;
    }

    .image-wrapper img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 35% 50%;
    }

    .about-brand-page__banner2 {
        .image-wrapper{
            height: 900px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: 45% 50%;
            }
        }
    }


    .sec-about .welcome-sec__advantages {
        padding: 50px 20px;
    }

    .about-brand-page__post-text .text-element {
        font-weight: 300;
        font-size: 11px !important;
        line-height: 120%;
        letter-spacing: 0;
    }

    .sec-about .store-body__video-container {
        .video-box {
            border-radius: 10px;
            overflow: hidden;
        }
        padding: 0 30px;
    }
}
</style>
